<template>
  <!-- <div class="loading_block_outer" v-if="loading">
      <Loading />
    </div> -->
  <!-- <div class="text-center" v-if="loading" >
    Loading..

  </div> -->

  <div class="dashboard-viewport-full-width">
    <Header />
    <!-- Unauthorized message -->
    <div v-if="!isDashboardAuthorized" class="unauthorized-message-container">
      <Card class="unauthorized-card">
        <template #content>
          <div class="icon-wrapper">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <h2 class="message-title">Access Denied</h2>
          <p class="message-text">You are not authorized to view this data.</p>
          <Button label="Go Back" icon="pi pi-arrow-left" class="p-button-secondary mt-4" @click="goBack" />
        </template>
      </Card>
    </div>
    <div v-else class="wrapper dashboard-page-full-width" @click="coloseProfile()">
      <div class="col-3" v-if="loading">
        <div class="snippet" data-title=".dot-spin">
          <div class="stage">
            <div class="dot-spin"></div>
          </div>
        </div>
      </div>

      <!-- desktop version starts here -->
      <div class="dashbrd-wrap">
        <div class="dashbrd-wrap_container dashboard-content-full-width">
          <div class="d-flex justify-content-center">
            <span id="errorList">{{ errorList }}</span>
          </div>

          <div class="dashboard-desktop-table-stack">
          <DashboardHeader
            v-model:filters="filters"
            v-model:selectedColumns="selectedColumns"
            :allColumns="getAllColumns"
            :assignActions="getAssignActions"
            :rmData="rmData"
            :distributorID="distributorID"
            :isUserActionsVisible="showAssignAction()"
            :isExportCsv="showExportCsv"
            :tableData="filteredProposals"
            @clear-filters="clearFilter"
            @export-csv="exportCSV"
            @file-upload="fileUpload"
            @handle-category-filter="handleCategoryFilter"
          />

          <CommonTableComponent
            ref="dt"
            :fill-viewport-height="true"
            viewport-height="100%"
            :tableData="filteredProposals"
            :columns="selectedColumns"
            :totalRecords="totalRecords"
            :rows="pageSize"
            :first="tableFirst"
            :rowLoading="loading"
            :dataFetched="!loading"
            :isSelectionEnabled="false"
            :isExpanderEnabled="false"
            :isExportCSV="false"
            :status-column-filter-options="motorDashboardStatusFilterOptions"
            :insurance-company-column-filter-options="insuranceCompanyFilterOptions"
            fileName="Dashboard_Data"
            tableHeader="Dashboard"
            dataKey="proposal_ui_id"
            :filters="filters"
            :isMenuVisible="showMenuActionsItems"
            :get-actions="getRowActions"
            :handleProposalJourney="isResumeJourney"
            :journeyStatusLabelFormatter="formatJourneyStatusLabel"
            :journeyStatusSeverity="getJourneyStatusTagSeverity"
            :isJourneyStatusInteractive="isJourneyStatusInteractive"
            :retriggerPaymentEnable="retriggerPaymentEnable"
            :showTrigger="true"
            :loadingMessage="lodingMessage"
            defaultSortField="created_at"
            :defaultSortOrder="-1"
            @update-with-filter="filterUpdate"
            @page-change="onPageChange"
            @handle-proposal-journey="handleJourneyStatusClick"
          />
          </div>
        </div>
      </div>
      <!-- desktop version ends here -->
      <!-- mobile version (aligned with health: DashboardHeader + DashboardCard) -->
      <div v-if="isDashboardAuthorized" class="dashboard-mobile-version">
        <DashboardHeader
          :isDesktop="false"
          v-model:filters="filters"
          v-model:selectedColumns="selectedColumns"
          :allColumns="getAllColumns"
          :assignActions="getAssignActions"
          :rmData="rmData"
          :distributorID="distributorID"
          :isUserActionsVisible="showAssignAction()"
          :tableData="filteredProposals"
          @clear-filters="clearFilter"
          @export-csv="exportCSV"
          @file-upload="fileUpload"
          @handle-category-filter="handleCategoryFilter"
        />
        <div class="d-flex justify-content-center px-3">
          <span id="errorList">{{ errorList }}</span>
        </div>
        <DashboardCard
          :proposal="filteredProposals"
          :selected-record="selectedProduct"
          :is-user-actions-visible="showAssignAction()"
          :is-journey-status-interactive="isJourneyStatusInteractive"
          :format-journey-status-label="formatJourneyStatusLabel"
          :get-journey-status-tag-severity="getJourneyStatusTagSeverity"
          :retrigger-payment-enable="retriggerPaymentEnable"
          :enable-upload-doc="enableUploadDoc"
          :is-invalid-policy-number="isInvalid"
          @update:selected-record="selectedProduct = $event"
          @resume-journey="handleJourneyStatusClick"
          @retrigger-payment="retriggerPayment"
          @view-requirements="onMobileViewRequirements"
        />
      </div>
    </div>
  </div>

  <ResendPaymentLinkStatus :status="this.linkStatus" :disablebtn="this.disablebtn" :errorStatus="this.errorStatus">
  </ResendPaymentLinkStatus>
</template>


<script>
import axios from "axios";
// import Header from "@/components/Header.vue";
import { getDistributer, getConsumer, getDashboardColumns, getRoleBasedColumns } from '@/mixins/common';
import { getSpFieldsForCommunicationPayload } from '@/mixins/utils';
import { buildAcceptReviewPayUrl } from '@/utils/proposalPaymentRetrigger';
import { ROLE_ID } from '@/constants/roles';
import { FilterMatchMode } from '@primevue/core/api';
import { extractInsuranceCompanies } from '@/utils/extractInsuranceCompanies';
import { shouldSkipGodigitKycOvd } from '@/utils/godigitKycOvdSkip';
import Button from 'primevue/button';
import Card from 'primevue/card';
import CommonTableComponent from '@/components/CommonTableComponent.vue';
import DashboardHeader from './DashboardHeader.vue';
import DashboardCard from './DashboardCard.vue';
// import Loading from "@/components/loading.vue";
// import ResendPaymentLinkStatus from "@/components/ResendPaymentStatusModal.vue"
import $ from "jquery";

/** Preset values for Status column filter (`value`; contains match mode from initFilters). */
const MOTOR_DASHBOARD_STATUS_FILTER_OPTIONS = [
  "Proposal Application Pending",
  "Requirements Pending",
  "Scrutiny",
  "Underwriting",
  "Accepted",
  "Counter Offer",
  "Rejected",
  "Policy Issued",
  "Proposal Submitted",
  "Proposal Modification Requested",
  "Awaiting Client Approval",
  "Proposal Error",
  "Payment Success",
  "Payment Failure",
  "Requirement Verification",
  "PreConversion",
  "Cancelled",
  "OTP Verified",
  "Document Upload Pending",
  "Quote Created",
  "Quote Selected",
  "Payment Initiated",
  "Proposal Submission Initiated",
  "Document Upload Initiated",
  "Quote Updated",
  "Payment Intimation Failed",
  "Documents Uploaded",
  "KYC Success",
  "KYC Failed",
  "INSPECTION REQUIRED",
  "INSPECTION APPROVED",
  "Payment Pending",
  "Journey Approved",
  "Payment Intimation Initiated",
  "Awaiting Checker Approval",
  "PIVC Initiated",
  "PIVC Success",
  "PIVC Failed",
  "PIVC Pending",
  "PIVC WaivedOff",
  "PIVC Hold",
  "PIVC InProgress",
  "Payment Intimation Success",
];

export default {
  name: "dashboard",
  props: {
    msg: String,
  },
  components: {
    Button,
    Card,
    CommonTableComponent,
    DashboardHeader,
    DashboardCard,
    //  Header,Loading,ResendPaymentLinkStatus
  },

  async mounted() {

    this.configData = this.$store.state.configData;
    if (this.configData) {
      this.distributorID = this.configData["DISTRIBUTER"]["distributerID"];
      this.ovdMode = this.configData["OVD_KYC"];
    }
    this.loading = true;
    let rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    this.initFilters();
    this.handleSelectedColumns();

    // Only proceed with data loading if authorized
    if (this.isDashboardAuthorized) {
      this.selectedPlan = JSON.parse(sessionStorage.getItem("selected_plan_data"));
      // console.log("type",typeof(sessionStorage.getItem("filledData")),sessionStorage.getItem("filledData"))
      this.formInfo = JSON.parse(sessionStorage.getItem("filledData"));
      console.log("filled details-", this.formInfo);
      if (rmData) {
        this.rmCode = rmData.Userid;
      }

      if (!this.$route.query.id) {
        await Promise.all([
          this.fetchInsuranceCompanyFilterOptions(),
          this.getdashboardData(),
        ]);
      }
    } else {
      this.loading = false; // Ensure loading is false if not authorized
    }
    sessionStorage.setItem('profileOpeningStatus', JSON.stringify(false));
    sessionStorage.removeItem("vahanData");
  },
  data() {
    return {
      startRange: 0,
      distributorID: "",
      enditems: 50,
      selectedColumns: [],
      selectedProduct: [],
      filters: {},
      rmData: null,
      lodingMessage: 'Fetching Dashboard Data.',
      selectedPlan: [],
      formInfo: [],
      searchQuery: "",
      filterText: "",
      hover: {},
      fltr: "",
      selected: "",
      /** PrimeVue DataTable column filter string(s), e.g. `value.contains.Proposal Application Pending` (same as health `filter` param). */
      primeFilter: "",
      filterColumn: {
        "Journey Id": "journey_id",
        "Customer Name": "name",
        "Mobile No.": "mobile_number",
        "Insurance Company": "insurance_company_code",
      },
      startDate: "",
      endDate: "",
      totalPages: 0,
      requirements: [],
      proposal: [],
      //   searchProposal:[],
      proposalNumber: "",
      rmCode: "",
      pageNumber: 0,
      pageSize: 50,
      pageSizeArray: [10, 20, 50],
      displayPage: 1,
      totalRecords: 0,
      loading: false,
      initCust: [],
      // Resume related
      proposalUiId: "",
      uiQuoteId: "",
      proposalDetails: "",
      quoteDetails: "",
      quoteResponseDetails: "",
      status: [],
      flag: false,
      childStatus: "",
      errorList: "",
      errorListTop: [],
      configData: "",
      linkStatus: "",
      disablebtn: true,
      errorStatus: "",
      productName: "",
      ovdMode: "",
      insuranceCompanyFilterOptions: [],
    };
  },
  methods: {
    async fetchInsuranceCompanyFilterOptions() {
      try {
        const resp = await this.backendApi(
          'getMotorUidataConfiguration',
          { stage: 'initial' },
          {},
          'post'
        );
        if (resp?.status === 'error' || resp?.data == null) {
          this.insuranceCompanyFilterOptions = [];
          return;
        }
        this.insuranceCompanyFilterOptions = extractInsuranceCompanies(resp);
      } catch {
        this.insuranceCompanyFilterOptions = [];
      }
    },
    // gtpageNumber() {
    //   if (this.goToPageNumber >= 1) {
    //     this.pageNumber = this.goToPageNumber - 1;
    //     await this.getdashboardData();
    //     this.displayPage = this.pageNumber + 1;
    //   }
    // },
    coloseProfile(){
      sessionStorage.setItem('profileOpeningStatus', JSON.stringify(false))
    },
    premiumRound(amount){
      return Math.round(amount);
    },
    isInvalid(value) {
      const trimmed = typeof value === 'string' ? value.trim().toLowerCase() : value;
      return (
        trimmed === null ||
        trimmed === undefined ||
        trimmed === false ||
        trimmed === 0 ||
        trimmed === '' ||
        trimmed === 'null' ||
        trimmed === 'undefined' ||
        trimmed === 'false' ||
        (Array.isArray(trimmed) && trimmed.length === 0) ||
        (typeof trimmed === 'object' && !Array.isArray(trimmed) && Object.keys(trimmed).length === 0)
      );
    },
    async reset() {
      this.searchQuery = "";
      this.fltr = "";
      this.startDate = "";
      this.endDate = "";
      this.filterText = "";
      this.selected = "";
      this.displayPage = 1;
      this.initFilters();
      await this.getdashboardData();
    },
    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    },
    /** Merge `DASHBOARD_COLUMNS` meta from `common.js` with motor-specific HTML templates. */
    enrichMotorColumn(col) {
      const c = { ...col };
      if (c.field === 'proposal_manu_id') {
        c.isHtml = true;
        c.bodyTemplate = (row) => {
          const num = !this.isInvalid(row.policy_number) ? row.policy_number : row.proposal_manu_id;
          return `<span class="app_no" style="font-weight:800;font-size:11px">${this.escapeHtml(String(num ?? '--'))}</span>`;
        };
      } else if (c.field === 'name') {
        c.isHtml = true;
        c.bodyTemplate = (row) => this.escapeHtml(String(row.name || '--').toUpperCase());
      } else if (c.field === 'line_of_business') {
        c.isHtml = true;
        c.bodyTemplate = (row) => this.escapeHtml(String(row.line_of_business || '--').toUpperCase());
      } else if (c.field === 'role') {
        c.isHtml = true;
        c.bodyTemplate = (row) => this.escapeHtml(String(row.role || '--').toUpperCase());
      }
      if (c.field === 'value') {
        c.isFilter = true;
      }
      return c;
    },
    handleSelectedColumns() {
      const consumer = getConsumer();
      const enrichedAll = this.getAllColumns;
      const defaults = consumer?.defaultSelectedColumns;
      if (defaults?.length) {
        this.selectedColumns = defaults
          .map((d) => {
            const match = enrichedAll.find((c) => c.field === d.field);
            return match ? { ...match } : this.enrichMotorColumn({ ...d });
          })
          .filter(Boolean);
      } else {
        this.selectedColumns = enrichedAll.map((c) => ({ ...c }));
      }
    },
    clearFilter() {
      const hadServerFilter = !!(this.selected || this.filterText || this.primeFilter);
      this.initFilters();
      this.selected = '';
      this.filterText = '';
      if (hadServerFilter) {
        this.getdashboardData();
      }
    },
    exportCSV() {
      this.$refs.dt?.exportCSV?.();
    },
    showAssignAction() {
      return false;
    },
    handleCategoryFilter($event) {
      sessionStorage.setItem('productType', JSON.stringify($event.value));
      this.primeFilter = "";
      this.selected = "";
      this.filterText = "";
      this.initFilters();
      this.getdashboardData();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        journey_id: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        proposal_manu_id: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        name: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        line_of_business: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        insurance_company_code: { constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        mobile_number: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        value: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        user_name: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        user_id: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        role: { constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
      };
      this.primeFilter = "";
    },
    /**
     * PrimeVue emits composite filter(s) like `value.contains.Proposal Application Pending`.
     * Pass through as `filter` query param (health parity); do not split into columnName + uppercased filterText
     * (backend would apply exact `value == filterText` and break case / contains semantics).
     */
    filterUpdate(val) {
      if (val === "") {
        this.primeFilter = "";
        this.selected = "";
        this.filterText = "";
        this.getdashboardData();
        return;
      }
      this.primeFilter = String(val);
      this.selected = "";
      this.filterText = "";
      this.getdashboardData();
    },
    onPageChange(event) {
      this.pageNumber = event.page;
      this.pageSize = event.rows;
      this.displayPage = event.page + 1;
      this.getdashboardData();
    },
    showMenuActionsItems(slotProps) {
      const user = slotProps?.data;
      if (!user) {
        return false;
      }
      return this.retriggerPaymentEnable(user);
    },
    copyPaymentLink(user) {
      const url = buildAcceptReviewPayUrl(user.journey_id);
      if (!url) {
        this.$toast?.add({
          severity: 'warn',
          summary: 'Copy Payment Link',
          detail: 'No journey reference available.',
          life: 3000,
        });
        return;
      }
      const onSuccess = () => {
        this.$toast?.add({
          severity: 'success',
          summary: url,
          detail: 'Payment link copied to clipboard',
          life: 3000,
        });
      };
      const onError = () => {
        this.$toast?.add({
          severity: 'error',
          summary: 'Copy failed',
          detail: 'Could not copy link to clipboard.',
          life: 3000,
        });
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(url).then(onSuccess).catch(onError);
        return;
      }
      try {
        const tempInput = document.createElement('input');
        tempInput.value = url;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        onSuccess();
      } catch {
        onError();
      }
    },
    getRowActions(slotProps) {
      const user = slotProps?.data;
      if (!user) {
        return [];
      }
      const checks = [
        {
          show: this.retriggerPaymentEnable(user),
          label: 'Resend payment link to customer',
          icon: 'pi pi-wallet',
          command: () => this.retriggerPayment(user),
        },
        {
          show: this.retriggerPaymentEnable(user),
          label: 'Copy Payment Link',
          icon: 'pi pi-copy',
          command: () => this.copyPaymentLink(user),
        },
      ];
      return checks.filter((c) => c.show).map(({ show, ...rest }) => rest);
    },
    formatJourneyStatusLabel(row) {
      if (row?.value === 'Scrutiny') {
        return 'INSPECTION REQUIRED';
      }
      return row?.value ? String(row.value).toUpperCase() : '--';
    },
    getJourneyStatusTagSeverity(row) {
      const cls = this.getResumeColor(row);
      const map = {
        'clr-yellow': 'warn',
        'clr-red': 'danger',
        'clr-scrutiny': 'warn',
        'clr-underwriting': 'info',
        'clr-green': 'success',
      };
      return map[cls] || 'info';
    },
    isJourneyStatusInteractive(row) {
      return this.canResumeProposalJourney(row);
    },
    /** True when status click will navigate (matches handleJourneyStatusClick; drives pointer cursor on status Tag). */
    canResumeProposalJourney(user) {
      const roleId = this.rmData?.RoleId ? String(this.rmData.RoleId) : null;
      if (roleId === ROLE_ID.ADMIN) {
        return this.isReadOnlyPage(user);
      }
      if (this.isReadOnlyPage(user)) {
        return true;
      }
      return this.isResumeJourney(user) || this.isPaymentResumeJourney(user);
    },
    handleJourneyStatusClick(user) {
      const roleId = this.rmData?.RoleId ? String(this.rmData.RoleId) : null;
      if (roleId === ROLE_ID.ADMIN) {
        if (this.isReadOnlyPage(user)) {
          sessionStorage.setItem('journey_id', JSON.stringify(user.journey_id));
          this.$router.push({ path: '/read-only-proposal-details', query: { journeyId: user.journey_id } });
        }
        return;
      }
      if (this.isPaymentResumeJourney(user)) {
        this.resumePayment(user);
        return;
      }
      this.resumeProposalJourney(user);
    },
    onMobileViewRequirements({ item, index }) {
      if (item) {
        this.getRequirements(item, index);
      }
    },
    isReadOnlyPage(user) {
      return ['Policy Issued', 'Underwriting', 'Rejected', 'Cancelled', 'Grace Period', 'Lapsed', 'Scrutiny', 'Inspection Required'].includes(user.value);
    },
    isPaymentResumeJourney(user) {
      return String(user?.value || '').toUpperCase() === 'PAYMENT INITIATED';
    },
    // goToReadOnlyPage(journeyid) {
    //   console.log('gotoreadonly called: ', journeyid);
    //   sessionStorage.setItem('journey_id', JSON.stringify(journeyid));
    //   this.$router.push({ path: '/read-only-proposal-details', query: { journeyId: journeyid } });
    // },
    async resumePayment(user) {
      const journey_id = user.journey_id;
      sessionStorage.setItem("journey_id", JSON.stringify(journey_id));
      try {
        this.$router.push('/confirm-payment-diy').then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 100)
        }).catch(err => {
          console.error('Navigation error:', err);
        });
      }catch(error){
        console.error(error)
      }
    },
    resultQuery() {
      this.proposal.splice(0, this.proposal.length, ...this.initCust);
      if (this.searchQuery !== "") {
        const results = this.initCust.filter((item) =>
          this.searchingFunc(item, this.searchQuery)
        );
        this.proposal.splice(0, this.proposal.length, ...results);
        this.startRange = this.proposal.length > 0 ? 1 : 0;
        this.enditems = this.proposal?.length;
      }
    },
    searchingFunc(obj, value) {
      for (let key in obj) {
        // Skip null or undefined values
        if (obj[key] === null || obj[key] === undefined) {
          continue;
        }
        
        try {
          // Convert the value to string for comparison, which works for all types
          const strValue = String(obj[key]).toLowerCase();
          const searchTerm = value.toLowerCase();
          
          if (strValue.indexOf(searchTerm) !== -1) {
            return true;
          }
        } catch (e) {
          // Skip any values that can't be converted to string
          continue;
        }
      }
      return false;
    },
    async filter() {
      this.errorList = ""
      this.errorList = ""
      if (((this.fltr != "") && (this.filterText != "")) || ((this.startDate != "") && (this.endDate != ""))) {
        this.primeFilter = "";
        this.selected = this.filterColumn[this.fltr];
        await this.getdashboardData();
      }
      else if (((this.fltr == "") && (this.filterText == "")) || ((this.startDate != "") && (this.endDate != ""))) {
        this.primeFilter = "";
        await this.getdashboardData();
      }
      else if (((this.fltr == "") && (this.filterText != ""))) {
        this.errorList = ""
        this.errorList = "Please select a filter"
        window.scrollTo(0, 0);
        // alert("Please select a Filter");
      }
      else if (this.filterText == "") {
        this.errorListTop = ""
        this.errorListTop = "Please enter a filter text"
        window.scrollTo(0, 0);
        // alert("Please enter a Filter Text");
      }

    },
    async getdashboardData() {
      this.loading = true;
      this.pageNumber = this.displayPage > 0 ? this.displayPage - 1 : 0;
      let endTime = '23:59:59';
      let startTime = '00:00:00';
      let qData = {
        pageSize: this.pageSize ? this.pageSize : '',
        pageNumber: this.pageNumber,
        columnName: this.primeFilter ? '' : (this.selected ? this.selected : ''),
        filterText: this.primeFilter ? '' : (this.filterText ? this.filterText.toUpperCase() : ''),
        startDate: this.startDate ? this.startDate : '',
        endDate: this.endDate ? this.endDate : '',
        filter: this.primeFilter || '',
      };
      let headers = {};

      try {
        const response = await this.backendApi("getDashboardData", qData, headers, "get");
        this.loading = false;

        this.proposal = response.data.data.resp;
        this.errorList = "";
        this.totalRecords = response.data.data.count;
        this.totalPages = Math.ceil(this.totalRecords / (this.pageSize || 50));
        this.enditems = this.proposal?.length + this.pageNumber * 50;
        this.startRange = this.pageNumber * 50 + 1;

        if (this.totalRecords == 0) {
          this.startRange = 0;
          this.displayPage = 0;
        }

        this.initCust = [];
        this.initCust.splice(0, this.proposal?.length, ...this.proposal);

        if (this.proposal?.length == 0) {
          this.pageNumber = this.displayPage - 1;
        }
        this.resultQuery();
      } catch (error) {
        this.loading = false;
        console.error('An error occurred while fetching dashboard data:', error);
        this.apiError = true;
      }
    },
    enableUploadDoc(user) {
      if (user.insurance_company_code === "HDFC") {
        return false;
      }
      if (["TATA", "ICICI"].includes(user.insurance_company_code)) {
        return ["Proposal Submitted", "Requirements pending"].includes(user.value);
      }
      return false;
    },
   async getProposalById(user) {
      const journey_id = user.journey_id;
      const qData = [journey_id, "Proposal Review", "false"];
      var headers = {
        Authorization:
          "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
        "Content-Type": "application/json",
      };
      const status= await this.checkProposalStatus(user.journey_id)
      if(status == 'Underwriting' || status == 'Policy Issued' || status=='Rejected')
      {
      console.log('gotoreadonly called1: ', user.journey_id);
      sessionStorage.setItem('journey_id', JSON.stringify(user.journey_id));
      this.$router.push({ path: '/read-only-proposal-details', query: { journeyId: user.journey_id } });
      return
      }
      if(status=='Proposal Submitted'){
        this.$router.push({ path: '/confirm-payment-diy', query: { journeyId: JSON.stringify(user.journey_id) } })
        return
      }
      this.backendApi("getProposalWithStage", qData, headers, "get")
        .then((response) => {
          this.proposalDetails = response.data.data.proposal;
          const proposalResponse = response.data.data.proposal.proposal_response;
          sessionStorage.setItem("filledData", JSON.stringify(this.proposalDetails.proposal_json));
          sessionStorage.setItem("proposal_ui_id", JSON.stringify(this.proposalDetails.proposal_ui_id));
          let spdetail_flag = process.env.VUE_APP_SPDETAIL_ONESB;
          if (spdetail_flag == 1) {
            if (sessionStorage.getItem("rm_data")) {
              this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
              this.getSPDetailsOneSB(this.rmData.UserId, response.data.data.quote_response.insurance_company_code);
            }
          }
          /* let vahanData = sessionStorage.getItem("vahanData") ? JSON.parse(sessionStorage.getItem("vahanData")) : "";
          if(!vahanData){
            this.getVahanData(response.data.data.quote_request.quote_request_json.product.registrationDetails.registrationNumber, response.data.data.quote_request.mobile_number);
          } */
          this.quoteDetails = response.data.data.quote_request;
          this.userDetails = response.data.data.user;
          localStorage.setItem("userProfile", JSON.stringify(this.userDetails));
          sessionStorage.setItem(
            "user_profile",
            JSON.stringify(this.userDetails)
          );
          sessionStorage.setItem(
            "quote_request",
            JSON.stringify(this.quoteDetails.quote_request_json)
          );
          let userData = {
            mobileNumber: String(response.data.data.proposal.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields?.mobileNumber?.input || ""),
            pinCode: response.data.data.quote_request?.zipcode || "",
            vehicleNumber: response.data.data.quote_request.quote_request_json?.product?.registrationDetails?.registrationNumber || "",
            state: "",
            city: "",
            rto: null,
            email: response.data.data.quote_request.quote_request_json?.personalInformation?.individualDetails[0]?.email || "",
            rtoCode: response.data.data.quote_request.quote_request_json?.product?.rtoLocationCode || "",
            MfgYear: Number(response.data.data.quote_request.quote_request_json?.product?.registrationDetails?.manufacturingYear || ""),
            carMake: {
              makeCode: response.data.data.quote_request.quote_request_json?.product?.vehicleDetails?.vehicleMakeCode || "",
              makeDescription: ""
            },
            model: {
              modelCode: response.data.data.quote_request.quote_request_json?.product?.vehicleDetails?.vehicleModelCode || "",
              modelDesc: ""
            },
            fuelType: response.data.data.quote_request.quote_request_json?.product?.vehicleDetails?.vehicleFuelType || "",
            variant: {
              variantCode: response.data.data.quote_request.quote_request_json?.product?.vehicleDetails?.vehicleVariantCode || "",
              variantDesc: ""
            },
            vehicleKey: response.data.data.quote_request.quote_request_json?.product?.vehicleDetails?.vehicleUniqueCode || "",
            RegDate: response.data.data.quote_request.quote_request_json?.product?.registrationDetails?.registrationDate || "",
            additonalDetails: "",
            OdDate: response.data.data.quote_response.quote_response_data?.productDetails?.previousPolicyDetails?.previousPolicyOdExpiryDate || "",
            TpDate: response.data.data.quote_response.quote_response_data?.productDetails?.previousPolicyDetails?.previousPolicyTpExpiryDate || "",
            applicablePercentage: response.data.data.quote_request.quote_request_json.product.ncbDetails.ncbPercentageLastYear || "0",
            percentOptions: ["0%", "20%", "25%"],
            idvSelector: "",
            prePolicyGreaterThan90Days: response.data.data.quote_request.quote_request_json?.product?.previousPolicyDetails?.IsPreviousPolicyExpired || false,
            PANNumber: response.data.data.proposal_details[0]?.details?.personalInformation?.pan || "",
            ckycRes: {
              status: response.data.data.proposal_details[0]?.details?.kycInfo?.Status || ""
            },
            quoteCategory: response.data.data.quote_request.quote_request_json?.quoteCategory
          }

          sessionStorage.setItem("userData", JSON.stringify(userData));
          sessionStorage.setItem("quoteSingleData", JSON.stringify([response.data.data.quote_response.quote_response_data]));
          this.quoteResponseDetails = response.data.data.quote_response;
          let pln = this.quoteResponseDetails.quote_response_data;
          sessionStorage.setItem("selected_plan_data", JSON.stringify(pln));
          sessionStorage.setItem(
            "selectedPlanForCheckout",
            JSON.stringify(pln)
          );
          sessionStorage.setItem(
            "resumeProfile",
            JSON.stringify(this.userDetails)
          );
          sessionStorage.setItem(
            "resume_proposal_flag",
            JSON.stringify(1)
          );
          sessionStorage.setItem('journey_id', JSON.stringify(user.journey_id));
          this.$store.commit('setJourneyId', user.journey_id);
          sessionStorage.setItem('resumeFromDashboard', JSON.stringify(true));
          const isUploadDocRequired = response.data.data.proposal_details[0]?.details?.kycInfo?.Status?.toLowerCase() == "approved" ? false : true;
          sessionStorage.setItem('isUploadDocRequired', JSON.stringify(isUploadDocRequired));
          sessionStorage.setItem('fromDashboard', JSON.stringify(true));
          setTimeout(() => {
            const skipGodigitOvd = shouldSkipGodigitKycOvd(pln);
            if (skipGodigitOvd) {
              sessionStorage.setItem('isUploadDocRequired', JSON.stringify(false));
            }
            if (!skipGodigitOvd && ["Documents Uploaded", "Document Upload Initiated"].includes(status) && this.ovdMode && this.ovdMode[user.insurance_company_code] !== 'POST_PROPOSAL') {
              this.$router.push("/upload-ovds");
            } else if (!skipGodigitOvd && status === 'KYC Failed') {
              this.$router.push("/ckyc-form");
            }
            else if (status == 'Scrutiny' && proposalResponse) {
              console.log("inspection page called")
              const inspectionLink = proposalResponse?.inspectionDetails?.selfInspectionLink;
            const inspectionvalidTill = proposalResponse?.inspectionDetails?.inspectionValidTill;
            if (inspectionLink) {
              sessionStorage.setItem("inspectionLink", JSON.stringify(inspectionLink));
            }
            if (inspectionvalidTill) {
              sessionStorage.setItem("inspectionvalidTill", JSON.stringify(inspectionvalidTill));
            }

            sessionStorage.setItem("payment-url-response", JSON.stringify(proposalResponse.policy))
            sessionStorage.setItem("payment-poll-url", JSON.stringify(proposalResponse.ManufacturerTracking))
            sessionStorage.setItem("propsalDetails_review", JSON.stringify(response.data.data));
            this.$router.push('/inspection');
            } else {
              if (status === "KYC Success") {
                sessionStorage.removeItem("filledData");
              }
              const kycResponse = response.data.data.proposal_details && response.data.data.proposal_details.length > 0 ? response.data.data.proposal_details[0]?.details : '';
              if(kycResponse){
                sessionStorage.setItem(
                  "kyc_response",
                  JSON.stringify(kycResponse)
                );
              }
              if(!response.data.data.proposal_details.length){
                sessionStorage.setItem("isOvdFlow", JSON.stringify(true));
              }
              let dashboardJourneyToProposal = {
                page: 'proposal',
                vehicleType: response.data.data.quote_request.quote_request_json.product.motorProductType,
                vehicleData: {
                  rtoCode: response.data.data.quote_request.quote_request_json.product.rtoLocationCode,
                  make: response.data.data.quote_request.quote_request_json.product.vehicleDetails.vehicleMakeCode,
                  model: response.data.data.quote_request.quote_request_json.product.vehicleDetails.vehicleModelCode,
                  variant: response.data.data.quote_request.quote_request_json.product.vehicleDetails.vehicleVariantCode,
                  fuelType: response.data.data.quote_request.quote_request_json.product.vehicleDetails.vehicleFuelType,
                  regDate: response.data.data.quote_request.quote_request_json.product.registrationDetails.registrationDate,
                  policyHolder: response.data.data.quote_request.quote_request_json.personalInformation.individualDetails[0].ownerBelongsToOrganizationFlag
                }
              };
              sessionStorage.setItem("filledData", JSON.stringify(response.data.data.proposal.proposal_json))
              sessionStorage.setItem("dashboardJourneyToProposal", JSON.stringify(dashboardJourneyToProposal))
              sessionStorage.setItem("resumeFromDashboard", JSON.stringify(true));
              this.$router.push("/process-wizard");
            }
          }, 1000);
        })
        .catch((error) => {
          console.log("error msg block dp", error);
        });
    },
    async getVahanData(regNo, mobileNumber){
      let rmData = JSON.parse(sessionStorage.getItem("rm_data"));
      const request = {
        "distributor": {
          "distributorID": this.distributorID,
          "agentID": this.getAgentIdFromRmData(rmData),
          "agentType": String(rmData.RoleId) === ROLE_ID.POSP ? "POSP" : "",
          "salesChannel": "",
          "channelType": String(rmData.RoleId) !== ROLE_ID.CONSUMER ? "B2B" : "B2C",
          "varFields": [
            {
              "fieldName": "",
              "fieldValue": ""
            }
          ]
        },
        "mobileNumber": mobileNumber,
        "registrationNumber": "CG04HT9859",
        "varFields": [
          {
            "fieldName": "manufacturerUniqueNo",
            "fieldValue": ""
          }
        ]
      }
      console.log("vahanData 1", JSON.parse(sessionStorage.getItem("vahanData")), regNo, mobileNumber)
      try {
        const response = await this.backendApi("vahanSearch", request, {"Authorization":`Bearer ${this.$store.state.token}`}, "post");
        
        if(response && response.data) {
          sessionStorage.setItem("vahanData", JSON.stringify(response.data.data));
        }
      }catch(error){

      }
    },
    getSPDetailsOneSB(rm_code, man_code) {
      let reqData = [man_code];
      let headers = {};
      this.backendApi("getSPDetailsOneSB", reqData, headers, "get")
        .then((response) => {
          if (response == 'error') {
            self.apiError = true;
          } else if (response && response.data) {
            console.log('response sp details: ', response.data);
            if (response.data.status == "failed") {
              //redirection to error page and on go back button redirect to homepage
              let msg = ['SP details are not available']
              this.$router.push({ path: '/networkalert', query: { backUrl: 'policy-quote', msg: msg } });
            }
            sessionStorage.setItem("sp_details_data", JSON.stringify(response.data.data));
            sessionStorage.setItem("sp_details_data", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          console.log('error msg block spdetailOneSB API', error);
          let msg = ['SP details are not available']
          this.$router.push({ path: '/networkalert', query: { backUrl: 'policy-quote', msg: msg } });
        });
    },
    // getQuoteDetails(ui_quote_id) {
    //   let qData = [ui_quote_id];
    //   var headers = {
    //     Authorization:
    //       "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
    //     "Content-Type": "application/json",
    //   };
    //   this.backendApi("getQuoteDetails", qData, headers, "get")
    //     .then((response) => {
    //       this.quoteDetails = response.data.data[0];
    //       // this.uiQuoteId = this.proposalDetails.ui_quote_id;

    //       this.userDetails = {
    //         gender: this.quoteDetails.gender,
    //         fullname: this.quoteDetails.life_assured_name,
    //         dob: this.quoteDetails.dob,
    //         age: null,
    //         mobile: this.quoteDetails.mobile_number,
    //         zipcode: this.quoteDetails.zipcode,
    //         annualincome: this.quoteDetails.annual_income,
    //         inlakhs: null,
    //         employmenttype: this.quoteDetails.employee_type,
    //         education: this.quoteDetails.education,
    //         smoke: this.quoteDetails.smoker,
    //         whatsapp: false,
    //         contactDetails: {
    //           mobileNumber: this.quoteDetails.mobile_number
    //         }
    //       };

    //       sessionStorage.setItem("resumeProfile", JSON.stringify(this.userDetails));
    //       // sessionStorage.setItem(
    //       //   "user_profile",
    //       //   JSON.stringify(this.userDetails)
    //       // );
    //       sessionStorage.setItem(
    //         "resumeProfile",
    //         JSON.stringify(this.userDetails)
    //       );
    //       sessionStorage.setItem(
    //         "resume_proposal_flag",
    //         JSON.stringify(1)
    //       );
    //       sessionStorage.setItem(
    //         "request_json",
    //         JSON.stringify(this.quoteDetails.quote_request_json)
    //       );

    //       // this.getQuoteResponseDetails(this.uiQuoteId);
    //     })
    //     .catch((error) => {
    //       console.log("error msg block dp", error);
    //     });
    // },

    // getQuoteResponseDetails(ui_quote_id) {
    //   console.log('getQuoteResponseDetails called: ', ui_quote_id)
    //   let qData = [ui_quote_id];
    //   var headers = {
    //     Authorization:
    //       "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
    //     "Content-Type": "application/json",
    //   };
    //   this.backendApi("getQuoteResponseDetails", qData, headers, "get")
    //     .then((response) => {
    //       console.log("quote response details: ", response.data.data);
    //       this.quoteResponseDetails = response.data.data;
    //       //let pln = JSON.parse(this.quoteResponseDetails.quote_response_data);
    //       let pln = this.quoteResponseDetails.quote_response_data;
    //       sessionStorage.setItem("selected_plan_data", JSON.stringify(pln));
    //       sessionStorage.setItem(
    //         "selectedPlanForCheckout",
    //         JSON.stringify(pln)
    //       );

    //       //let reqData = [this.userDetails.mobile, this.userDetails.dob];
    //       let reqData = [this.userDetails.mobile, this.proposalDetails.dob];
    //       // this.getLogData(reqData);
    //       sessionStorage.setItem(
    //         "filledDataTab",
    //         JSON.stringify(this.proposalDetails.tag_name)
    //       );
    //       sessionStorage.setItem(
    //         "currentTab",
    //         this.proposalDetails.tag_name
    //       );
    //       let productGroupId = JSON.parse(sessionStorage.getItem("filledData")).productGroupId;
    //       setTimeout(() => {
    //         // if(productGroupId == 'health') {
    //         this.$router.push("/proposer-details");
    //         // } else {
    //         //   this.$router.push("/proposal");
    //         // }

    //       }, 1000);
    //     })
    //     .catch((error) => {
    //       console.log("error msg block quote response", error);
    //     });
    // },
    getLogData(qData) {
      var headers = {
        Authorization:
          "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
        "Content-Type": "application/json",
      };
      this.backendApi("getLogData", qData, headers, "get")
        .then((response) => {
          console.log("log data response details: ", response.data.data);
          this.logDetails = response.data.data;
          sessionStorage.setItem(
            "filledDataTab",
            JSON.stringify(this.logDetails.tag_name)
          );
          sessionStorage.setItem(
            "currentTab",
            JSON.stringify(this.logDetails.tag_name)
          );

          let productGroupId = JSON.parse(sessionStorage.getItem("filledData")).productGroupId;

          console.log('productGroupId: ', productGroupId);

          setTimeout(() => {
            if (productGroupId == 'health') {
              this.$router.push("/proposer-details");
            } else {
              this.$router.push("/proposal");
            }

          }, 1000);
        })
        .catch((error) => {
          console.log("error msg block dp", error);
        });
    },
    async personalDetails(journey_id) {
      const qData = [journey_id, "Proposal Review", "false"];
      var headers = {
        Authorization:
          "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
        "Content-Type": "application/json",
      };
      const response = await this.backendApi("getProposalWithStage", qData, headers, "get");
      if (response && response.data && response.data.data) {
        this.productName = response.data.data.quote_response.quote_response_data.insuranceAndProducts.productName
        var fullName = '';
        if (response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName && response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input) {
          fullName = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input + " " + response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input + " " + response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input;
        } else {
          fullName = response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input + " " + response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input
        }
        const result = {
          fullName: fullName,
          email: response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input,
          mobileNumber: response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.mobileNumber.input,
          insuranceCompanyName: response.data.data.quote_response.quote_response_data.insuranceAndProducts.insuranceCompanyName,
          planName: response.data.data.quote_response.quote_response_data.productDetails.planOption.planName
        }
        return result;
      }
      const result = {
        fullName: "",
        email: "",
        mobileNumber: "",
      }
      return result;
    },
    async retriggerPayment(user) {
      this.loading = true;
      this.disablebtn = true;
      this.errorStatus = 'sending'
      this.linkStatus = "Resending Payment Link"
      const personalDetails = await this.personalDetails(user.journey_id);
      const distributorID = getDistributer()["distributerID"];
      const rmData = JSON.parse(sessionStorage.getItem("rm_data"));
      const resumeLink = buildAcceptReviewPayUrl(user.journey_id);
      const spFields = getSpFieldsForCommunicationPayload();
      const reqData = {
        "distributor": {
          "distributorID": distributorID,
          "agentID": this.getAgentIdFromRmData(rmData),
          "agentType": String(rmData.RoleId) === ROLE_ID.POSP ? "POSP" : "",
          "salesChannel": "",
          "channelType": String(rmData.RoleId) !== ROLE_ID.CONSUMER ? "B2B" : "B2C",
          "varFields": [{
            "fieldName": "",
            "fieldValue": ""
          }]
        },
        "eventName": "reviewAndPay",
        "data": [
          {
            "resumeLink": resumeLink,
            "mobileNumber": personalDetails.mobileNumber,
            "channel": "sms",
            ...spFields
          },
          {
            "resumeLink": resumeLink,
            "fullName": personalDetails.fullName,
            "productName": personalDetails.planName,
            "emailId": personalDetails.email,
            "channel": "email",
            "premiumAmount": user.total_premium,
            "insuranceCompany": personalDetails.insuranceCompanyName,
            ...spFields
          }
        ]

      }
      const headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      const response = await this.backendApi('sendEmailandSMS', reqData, headers);
      if (response && response.data && response.data.data.msg === "User communicated successfully") {
        this.linkStatus = response.data.data.msg
        this.disablebtn = false;
        this.loading = false;
        this.errorStatus = "success";
      }
      else {
        this.linkStatus = response.data.errors[0].errorDisplayMessage;
        this.disablebtn = false;
        this.errorStatus = "error";
      }
      console.log("response ==> ", response);
    },
    getEmailIds(email) {
      if (getOperationEmail().includes(email)) {
        return [...getOperationEmail()];
      } else {
        return [email, ...getOperationEmail()]
      }
    },
    retriggerPaymentEnable(user) {
      const roleId = this.rmData?.RoleId ? String(this.rmData.RoleId) : null;
      const configData = this.$store.state.configData;
      const sendPaymentLinkAllowed = configData?.UI_CONFIG?.ROLE_ID?.[roleId]?.sendPaymentLink === true;
      if (!sendPaymentLinkAllowed) {
        return false;
      }
      const ovd = this.ovdMode?.[user.insurance_company_code];
      if (ovd === "POST_PROPOSAL" && ["Documents Uploaded", "Document Upload Initiated"].includes(user.value)) {
        return true;
      }
      if (['Proposal Submitted', 'Awaiting Client Approval', 'Payment Failure', 'Payment Initiated'].includes(user.value)) {
        return true;
      }
      return false;
    },
    getResumeColor(user) {
      if (user.value == 'Proposal Application Pending' || user.value == 'Awaiting Client Approval') {
        return 'clr-yellow';
      } else if (user.value == 'Proposal Error') {
        return 'clr-red';
      }else if(user.value=='Scrutiny' || user.value=='Payment Initiated' || user.value=='Inspection Required'){
        return 'clr-scrutiny';
      }else if(user.value=='Underwriting'){
        return 'clr-underwriting'
      }
      else {
        return 'clr-green';
      }
    },
    isResumeJourney(user) {
      const roleId = this.rmData?.RoleId ? String(this.rmData.RoleId) : null;
      if ([ROLE_ID.ADMIN, ROLE_ID.TELE_OPERATOR, ROLE_ID.ROLE_7, ROLE_ID.ROLE_8, ROLE_ID.TELE_MARKETER].includes(roleId)) {
        return false;
      }
      const ovd = this.ovdMode?.[user.insurance_company_code];
      if (["Documents Uploaded", "Document Upload Initiated"].includes(user.value) && ovd !== "POST_PROPOSAL") {
        return true;
      }
      const resumable = [
        'Proposal Application Pending',
        'Proposal Modification Requested',
        'Awaiting Client Approval',
        'Proposal Error',
        'KYC Success',
        'KYC Failed',
        'Underwriting',
        'Policy Issued',
        'Scrutiny',
        'Inspection Required',
        'Rejected',
        'Cancelled',
        'Proposal Submitted',
      ];
      return resumable.includes(user.value);
    },
    resumeProposalJourney(user) {
      this.getProposalById(user);
    },
    getProposal(journey_id) {
      let qData = [journey_id, "Proposal Review", "false"];
      var headers = {
        Authorization:
          "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
        "Content-Type": "application/json",
      };
      return this.backendApi("getProposalWithStage", qData, headers, "get")
        .then((response) => {
          this.proposalDetails = response.data.data.proposal;
          let resp = JSON.parse(this.proposalDetails.proposal_json)
          sessionStorage.setItem("filledData", this.proposalDetails.proposal_json);
          return resp;
        }) //proposal_ui_id, uiQuoteId,
        .catch((error) => {
          console.log("error msg block dp", error);
        });
    },
    // getQuote(ui_quote_id) {
    //   let qData = [ui_quote_id];
    //   var headers = {
    //     Authorization:
    //       "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
    //     "Content-Type": "application/json",
    //   };
    //   return this.backendApi("getQuoteResponseDetails", qData, headers, "get")
    //     .then((response) => {
    //       console.log("quote response details: ", response.data.data);
    //       this.quoteResponseDetails = response.data.data;
    //       //let pln = JSON.parse(this.quoteResponseDetails.quote_response_data);
    //       let pln = this.quoteResponseDetails.quote_response_data;
    //       console.log(pln)
    //       return pln;
    //     })
    //     .catch((error) => {
    //       console.log("error msg block quote response", error);
    //     });
    // },
    // updateProposalStatus(puid, statusid) {
    //   let qData = {
    //     "proposal_ui_id": puid,
    //     "status_id": statusid
    //   };
    //   var headers = {
    //     Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
    //     "Content-Type": "application/json",
    //   };

    //   this.backendApi("ProposalStatus", qData, headers)
    //     .then((response) => {
    //       if (response == 'error') {
    //         self.apiError = true;
    //       } else if (response && response.data) {
    //         console.log('proposal status updated: ', response.data)
    //       }
    //     })
    //     .catch((error) => {
    //       console.log('error msg block email', error);
    //     });
    // },
    goBack() {
      // this.$router.push("");
      this.$router.push({ path: '/' });
    },
    docuploadlink(user) {
      let qData = [user.journey_id, "Proposal Review", "false"];
      let headers = {};
      this.backendApi("getProposalWithStage", qData, headers, "get")
        .then((response) => {
          this.proposalDetails = response.data.data.proposal;
          // this.uiQuoteId = this.proposalDetails.ui_quote_id;

          sessionStorage.setItem(
            "filledData",
            JSON.parse(this.proposalDetails.proposal_json)
          );
          sessionStorage.setItem(
            "filledData",
            this.proposalDetails.proposal_json
          );
          sessionStorage.setItem(
            "proposal_ui_id",
            JSON.stringify(this.proposalDetails.proposal_ui_id)
          );
          /* sessionStorage.setItem(
            "uiQuoteId",
            JSON.stringify(this.proposalDetails.ui_quote_id)
          ); */

        })
        .catch((error) => {
          console.log("error msg block dp", error);
        });

      let link = "/#/upload-doc?distributorID=" + this.distributorID + "&insuranceCompanyCode=" + user.insurance_company_code + "&applicationNo=" + user.proposal_manu_id + "&productCode=" + user.product_code;
      if (user.value == "Proposal Submitted" || user.value == "Requirements pending") {
        if (user.insurance_company_code == "ICICI") {
          let headers = {
            Authorization: "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
            "Content-Type": "application/json",
          };
          this.backendApi("getResumeURL", qData, headers, "get")
            .then((response) => {
              if (response == 'error') {
                self.apiError = true;
              } else if (response && response.data) {
                if (response.data[1]['resumeURL'] != '')
                  window.location.href = response.data[1]['resumeURL'];
              }
            })
            .catch((error) => {
              console.log('error msg block dp', error);
            });
        }
        else {
          window.location.href = new URL(location).origin + link;
        }
      }
      // return link;
    },
    getRequirements(user, index) {
      this.requirements = [];
      this.childStatus = index
      const headers = {};

      const qData = [user.journey_id, "Proposal Review", "false"];
      this.backendApi("getProposalWithStage", qData, headers, "get")
        .then((response) => {
          this.proposalDetails = response.data.data.proposal;
          // this.uiQuoteId = this.proposalDetails.ui_quote_id;

          sessionStorage.setItem(
            "filledData",
            JSON.parse(JSON.stringify(this.proposalDetails.proposal_json))
          );
          sessionStorage.setItem(
            "filledData",
            JSON.stringify(this.proposalDetails.proposal_json)
          );
          sessionStorage.setItem(
            "proposal_ui_id",
            JSON.stringify(this.proposalDetails.proposal_ui_id)
          );
          /* sessionStorage.setItem(
            "uiQuoteId",
            JSON.stringify(this.proposalDetails.ui_quote_id)
          ); */

        })
        .catch((error) => {
          console.log("error msg block dp", error);
        });


    },
    changeDateFormat(inp) {
      var str = "";
      let monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      var d;
      if (typeof inp == typeof str) {
        d = new Date(Date.parse(inp));
        str =
          d.getDate().toString() +
          "-" +
          monthNames[d.getMonth()] +
          "-" +
          d.getFullYear().toString();
      }
      return str;
    },
    fileUpload() {
      this.$router.push('/sp-management');
    },
    async checkProposalStatus(journeyId) {
      this.loading = true
      let qData = [journeyId];
      var headers = {
        "Content-Type": "application/json",
      };

      try {
        const response = await this.backendApi(
          "getProposalStatus",
          qData,
          headers,
          "get"
        );
        this.loading = false
        return response.data.data.journey_status;

      } catch (error) {
        console.log("Error:", error);
      }
    }
  },
  computed: {
    motorDashboardStatusFilterOptions() {
      return MOTOR_DASHBOARD_STATUS_FILTER_OPTIONS;
    },
    isDashboardAuthorized() {
      const configData = this.$store.state.configData;
      const rmDataStr = sessionStorage.getItem("rm_data");
      let rmData = null;
      try {
        if (rmDataStr) {
          rmData = JSON.parse(rmDataStr);
        }
      } catch (error) {
        console.error("Error parsing rm_data:", error);
      }
      
      // If rmData is not available, default to true (allow access)
      if (!rmData) {
        return true;
      }
      
      const roleId = rmData.RoleId ? String(rmData.RoleId) : null;
      
      // Consumer (Role ID 1) should not have dashboard access
      if (roleId === ROLE_ID.CONSUMER) {
        return false;
      }
      
      // If configData is not available, default to true (allow access)
      if (!configData) {
        return true;
      }
      
      const uiConfig = configData?.UI_CONFIG;
      
      if (uiConfig?.ROLE_ID && roleId && uiConfig.ROLE_ID[roleId]) {
        const roleConfig = uiConfig.ROLE_ID[roleId];
        // Check dashboard permission, default to true if not explicitly false
        if (typeof roleConfig.dashboard === 'boolean') {
          return roleConfig.dashboard;
        }
      }
      
      // Default to true
      return true;
    },
    getAllColumns() {
      const allColumns = getDashboardColumns();
      const roleBasedColumns = getRoleBasedColumns();
      const roleId = this.rmData?.RoleId;
      const allowed = roleBasedColumns[roleId] ?? roleBasedColumns[String(roleId)];
      const filtered = allowed?.length
        ? allColumns.filter((col) => allowed.includes(col.field))
        : allColumns;
      return filtered.map((col) => this.enrichMotorColumn(col));
    },
    filteredProposals() {
      const raw = this.filters?.global?.value;
      const q = typeof raw === 'string' ? raw.trim().toLowerCase() : String(raw ?? '').toLowerCase();
      if (!q) {
        return this.proposal;
      }
      const fields = (this.selectedColumns || [])
        .map((c) => c?.field)
        .filter(Boolean);
      const scanRow = (obj) => {
        if (fields.length) {
          return fields.some((f) => {
            const val = obj[f];
            return val != null && String(val).toLowerCase().includes(q);
          });
        }
        return Object.values(obj).some((val) =>
          String(val).toLowerCase().includes(q)
        );
      };
      return this.proposal.filter(scanRow);
    },
    getAssignActions() {
      return [];
    },
    showExportCsv() {
      const id = this.rmData?.RoleId != null ? String(this.rmData.RoleId) : '';
      return [ROLE_ID.RM, ROLE_ID.ADMIN].includes(id);
    },
    tableFirst() {
      return Math.max(0, this.pageNumber * this.pageSize);
    },
    maxDate() {
      const today = new Date().toISOString().split("T")[0];
      return today;
    },

  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/dashboard.scss";
/* Prime dashboard/table dark UI: `@/assets/scss/components/motor-dashboard-prime-dark.scss` (main.js) */

#goToPageNumber {
  width: 175px;
}



#errorList {
  color: red;

}

#errorListTop {
  color: red;

}
.pagination-bottom{
  margin-bottom: 120px;
}

.dot-spin {
  position: fixed;
  right: 50%;
  bottom: 50%;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: transparent;
  color: transparent;
  box-shadow: 0 -18px 0 0 #9880ff, 12.72984px -12.72984px 0 0 #9880ff,
    18px 0 0 0 #9880ff, 12.72984px 12.72984px 0 0 rgba(152, 128, 255, 0),
    0 18px 0 0 rgba(152, 128, 255, 0),
    -12.72984px 12.72984px 0 0 rgba(152, 128, 255, 0),
    -18px 0 0 0 rgba(152, 128, 255, 0),
    -12.72984px -12.72984px 0 0 rgba(152, 128, 255, 0);
  animation: dotSpin 1.5s infinite linear;
}

@keyframes dotSpin {

  0%,
  100% {
    box-shadow: 0 -18px 0 0 #9880ff, 12.72984px -12.72984px 0 0 #9880ff,
      18px 0 0 0 #9880ff, 12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0);
  }

  12.5% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.72984px -12.72984px 0 0 #9880ff, 18px 0 0 0 #9880ff,
      12.72984px 12.72984px 0 0 #9880ff, 0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0);
  }

  25% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0), 18px 0 0 0 #9880ff,
      12.72984px 12.72984px 0 0 #9880ff, 0 18px 0 0 #9880ff,
      -12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0);
  }

  37.5% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0), 12.72984px 12.72984px 0 0 #9880ff,
      0 18px 0 0 #9880ff, -12.72984px 12.72984px 0 0 #9880ff,
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0);
  }

  50% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0), 0 18px 0 0 #9880ff,
      -12.72984px 12.72984px 0 0 #9880ff, -18px 0 0 0 #9880ff,
      -12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0);
  }

  62.5% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0), -12.72984px 12.72984px 0 0 #9880ff,
      -18px 0 0 0 #9880ff, -12.72984px -12.72984px 0 0 #9880ff;
  }

  75% {
    box-shadow: 0 -18px 0 0 #9880ff,
      12.72984px -12.72984px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0), -18px 0 0 0 #9880ff,
      -12.72984px -12.72984px 0 0 #9880ff;
  }

  87.5% {
    box-shadow: 0 -18px 0 0 #9880ff, 12.72984px -12.72984px 0 0 #9880ff,
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.72984px 12.72984px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0), -12.72984px -12.72984px 0 0 #9880ff;
  }
}

// .pagination .btn-next
// .pagination .btn-prev
//   {
//   background: none;
//   border-radius: 0.375rem;
//   font-weight: 500;
//   font-size: 1.0rem;
//   font-family: Poppins, Helvetica, sans-serif;
// }
.title .tooltiptext {
  visibility: hidden;
  width: 120px;
  text-align: left;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  right: 70px;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.title:hover .tooltiptext {
  visibility: visible;
}

@media screen and (max-width: 1439px) and (min-width: 992px) {
  .col-action {
    // position: absolute;
    // right: 0;
    // opacity: 0;
    // pointer-events: none;
  }

  .td-action {
    // width: auto;
    // padding: 0 !important;
    // position: absolute !important;
    // right: 50px;
    // top: 55px;
    // background: transparent !important;
    position: relative;
  }

  .hover-action {
    // position: absolute;
    // top: 0;
    // right: 0;
    border-radius: 5px;
    // background-color: #fff !important;
    // box-shadow: 0px 1px 3px 1px rgba(153, 153, 153, 0.3);
    z-index: 8;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // opacity: 0;
    transition: 0.3s all;
    // transform: scale(0);
    transform-origin: top center;
  }

  .hover-action:before {
    // content: "";
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 5px 7px 5px;
    border-color: transparent transparent rgb(153, 153, 153, 0.5) transparent;
    transform: rotate(0deg);
    position: absolute;
    right: 18px;
    top: -7px;
  }

  .td-action button {
    margin: 0px;
  }

  .content-row-inner:hover .hover-action {
    // opacity: 1;
    // pointer-events: all;
    // transform: scale(1);
  }
}
.dashboardfilter{
  width: 15px;
}

/* Table header styles to prevent line breaks */
.dashbrd-table th {
  white-space: nowrap;
  padding: 10px 8px;
}

.dashboard-viewport-full-width {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.dashboard-page-full-width {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Full-width dashboard content (avoid global .container max-width: 1275px) */
.dashboard-content-full-width {
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: clamp(12px, 2vw, 28px);
  padding-right: clamp(12px, 2vw, 28px);
  box-sizing: border-box;
}

.dashbrd-wrap_container {
  // overflow-x: auto;
}

/* Fills viewport below `.dashbrd-wrap` top offset (~app header) and fixed `innerFooter` (see `--app-fixed-footer-reserve`). */
.dashboard-desktop-table-stack {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px - var(--app-fixed-footer-reserve, 5.5rem));
  min-height: 0;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  input[type="date"] {
    position: relative;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: textfield;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.calender-img {
  position: absolute;
  top: 10px;
  right: 7px;
  bottom: 0;
  width: 15px;
  height: 15px;
  z-index: 1;
}
.data-placeholder {
  position: absolute;
  top: 10px;
  left: 12px;
  font-size: 0.813rem;
  z-index: 1;
}

.dark {
  .data-placeholder{
    color: white;
  }
}

/* Unauthorized message styles */
.unauthorized-message-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 200px);
  padding: 2rem;
}

.unauthorized-card {
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.icon-wrapper {
  font-size: 4rem;
  color: #f59e0b;
  margin-bottom: 1rem;
}

.message-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1f2937;
}

.message-text {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}
</style>